import { merge } from "lodash-es";
import frJson from "./fr.json";
import { TEAM_FR_FR } from "#pages/team/translations/team-fr-fr";
import { delivery } from "./place/delivery";
import { USER_BONUS_TABLE_FR_FR } from "#components/tables/reports/user-bonus-table/translations";
import { TRANSACTIONAL_HISTORY_TABLE_FR_FR } from "#pages/event/event-client-detail/client-info/transactional-history/transactional-history-table/translations";
import { TRANSACTIONAL_HISTORY_FR_FR } from "#pages/event/event-client-detail/client-info/transactional-history/translations";
import { BONUS_REPORT_AT_EVENT_FR_FR } from "#pages/event/event-reports/bonus-report-at-event/translations";
import { BONUS_BY_PRODUCT_TABLE_FR_FR } from "#components/tables/reports/bonus-by-product-table/translations";
import { BONUS_BY_PRODUCT_CARDS_FR_FR } from "#components/bonus-by-product-cards/translations";
import { vendors_FR_FR } from "#pages/org/vendors/translations";
import { BARS_AND_SECTORS_FR_FR } from "#pages/place/bars/translations/bars-and-sectors-fr-fr";
import { BONUS_CATEGORIES_FR_FR } from "#pages/place/bonus-categories/translations";
import { EXTRACT_FR_FR } from "#pages/place/extract-new/translations/extract-fr-fr";
import { BONUS_REPORT_FOR_PLACE_FR_FR } from "#pages/place/financial-reports/bonus-report-for-place/translations";
import { BONUS_REPORT_FR_FR } from "#pages/place/financial-reports/bonus-report/translations";
import { USED_BONUS_REPORT_FR_FR } from "#pages/place/financial-reports/bonus-report/used-bonus-report/translations";
import { precharge_FR_FR } from "#pages/place/precharge/pages/translations";
import { IMPORT_FR_FR } from "#pages/place/purchase-invoice/import-invoice/translations/import-fr-fr";
import { PURCHASE_INVOICE_FR_FR } from "#pages/place/purchase-invoice/translations/purchase-invoice-fr-fr";
import { backofficeFr as backoffice } from "./backoffice";
import { components } from "./components";
import { event } from "./event";
import { navFR } from "./nav";
import { noAuthFR as noAuth } from "./no-auth";
import { HAWKERS_REPORT_FR_FR } from "#pages/event/hawkers-report/translations";
import { products } from "./place/products";
import { integrations } from "./org/integrations";
import { categories } from "./org/categories";
import { cdp } from "./org/cdp";
import { emissionErrors } from "./place/emission-errors";
import vendor from "./place/settings/vendor.json";
import { REGISTER_EMAIL_FR_FR } from "./recovery/register-email";
import { MANAGER_ORDERS_FR_FR } from "./place/manager-orders";
import { placeData } from "./place/place-data";
import { TRANSACTIONS_REPORT_FR_FR } from "#components/transactions-report/translations";
import { ORG_PRODUCTS_FR_FR } from "./org/products";
import { COVERT_FR_FR } from "#pages/place/settings/couvert/translations";

const bonusByProduct = merge(
	{
		cards: BONUS_BY_PRODUCT_CARDS_FR_FR,
	},
	BONUS_BY_PRODUCT_TABLE_FR_FR,
);

const financialReport = {
	tabs: {
		bonusByProduct,
	},
};

const productsWebSettings = {
	tabs: {
		personalization: "Personnalisation du menu",
		banners: "Bannières",
		featured: "Mise en avant",
	},
	personalizationTab: {
		displayTitle: "Affichage",
		displayDescription:
			"Contrôlez quelles sections apparaissent pour les clients dans les menus numériques.",
		showBanners: "Afficher les bannières",
	},
	featuredTab: {
		title: "Section mise en avant",
		description:
			"Composez la suggestion du jour du menu numérique : choisissez le titre, activez la section et organisez les produits mis en avant dans l'ordre souhaité.",
		titleFieldLabel: "Titre de la section",
		titleFieldPlaceholder: "Ex. : Suggestions du jour",
		activeLabel: "Section active",
		activeDescription:
			"Lorsqu'elle est active, la section mise en avant apparaît sur le menu numérique.",
		productsFieldLabel: "Produits mis en avant",
		productsFieldDescription:
			"Ajoutez des produits et faites-les glisser pour définir l'ordre d'affichage.",
		productsPlaceholder: "Rechercher et ajouter des produits",
		emptySelection:
			"Aucun produit mis en avant pour le moment. Ajoutez des produits ci-dessus.",
		reorderProduct: "Réordonner le produit",
		removeProduct: "Retirer le produit",
		save: "Enregistrer les modifications",
		saving: "Enregistrement...",
		toastSuccess: "Section mise en avant enregistrée avec succès",
		toastError: "Impossible d'enregistrer la section mise en avant. Veuillez réessayer.",
		noMenuTitle: "Aucun menu numérique trouvé",
		noMenuDescription:
			"Créez un menu numérique pour configurer la section mise en avant.",
		languages: {
			ptBR: "Portugais",
			enUs: "Anglais",
			esMx: "Espagnol",
		},
	},
	bannersTab: {
		title: "Bannières de campagne",
		description:
			"Créez et organisez les bannières affichées en haut et entre les sections du menu numérique. Faites glisser pour réordonner.",
		addBanner: "Ajouter une bannière",
		empty: {
			title: "Aucune bannière créée",
			description:
				"Créez des bannières de campagne pour mettre en avant des promotions et des nouveautés dans le menu numérique.",
			action: "Ajouter une bannière",
		},
		slots: {
			hero: "Haut (à la une)",
			between_sections: "Entre les sections",
		},
		status: {
			active: "Active",
			inactive: "Inactive",
		},
		card: {
			noTitle: "Sans titre",
			edit: "Modifier la bannière",
			delete: "Retirer la bannière",
			dragHint: "Faites glisser pour réordonner",
		},
		form: {
			createTitle: "Ajouter une bannière",
			editTitle: "Modifier la bannière",
			image: "Image",
			imageHint: "Nous recommandons 1280x720 (ratio 16:9), aux formats .PNG ou .JPEG.",
			imageRequired: "L'image est obligatoire.",
			title: "Titre",
			titlePlaceholder: "Ex. : Combo d'été",
			subtitle: "Sous-titre",
			subtitlePlaceholder: "Ex. : Commandez dès maintenant et profitez-en",
			linkUrl: "Lien",
			linkUrlPlaceholder: "https://...",
			slot: "Position",
			slotHero: "Haut (à la une)",
			slotBetweenSections: "Entre les sections",
			targetType: "Ciblage",
			targetNone: "Aucun",
			targetProduct: "Produit",
			targetCategory: "Catégorie",
			targetProductPlaceholder: "Sélectionnez le produit",
			targetCategoryPlaceholder: "Sélectionnez la catégorie",
			startsAt: "Début",
			endsAt: "Fin",
			isActive: "Bannière active",
			cancel: "Annuler",
			save: "Enregistrer",
			create: "Ajouter",
		},
		delete: {
			title: "Retirer la bannière",
			descriptionPrefix: "Êtes-vous sûr de vouloir retirer la bannière ",
			descriptionSuffix: " ? Cette action est irréversible.",
			fallbackName: "sans titre",
			cancel: "Annuler",
			confirm: "Retirer",
		},
		toast: {
			createSuccess: "Bannière créée avec succès",
			editSuccess: "Bannière mise à jour avec succès",
			deleteSuccess: "Bannière retirée avec succès",
			reorderSuccess: "Ordre des bannières mis à jour",
			error: "Impossible de terminer l'action. Veuillez réessayer.",
		},
	},
};

const fr = merge(frJson, {
	components,
	backoffice,
	nav: navFR,
	place: {
		purchaseInvoiceV2: PURCHASE_INVOICE_FR_FR,
		import: IMPORT_FR_FR,
		delivery,
		emissionErrors,
		settings: {
			vendor,
			couvertEdit: COVERT_FR_FR,
			productsWeb: productsWebSettings,
		},
		extractNew: EXTRACT_FR_FR,
		bonusCategories: BONUS_CATEGORIES_FR_FR,
		usedBonusReport: USED_BONUS_REPORT_FR_FR,
		bonusReport: BONUS_REPORT_FR_FR,
		userBonusTable: USER_BONUS_TABLE_FR_FR,
		bonusReportForPlace: BONUS_REPORT_FOR_PLACE_FR_FR,
		financialReport,
		barsAndSectors: BARS_AND_SECTORS_FR_FR,
		products,
		precharge: precharge_FR_FR,
		placeData,
		transactionsReport: TRANSACTIONS_REPORT_FR_FR,
		managerOrders: MANAGER_ORDERS_FR_FR,
	},
	event: {
		userBonusTable: USER_BONUS_TABLE_FR_FR,
		bonusReportAtEvent: BONUS_REPORT_AT_EVENT_FR_FR,
		transactionalHistory: TRANSACTIONAL_HISTORY_FR_FR,
		transactionalHistoryTable: TRANSACTIONAL_HISTORY_TABLE_FR_FR,
		financialReport,
		hawkersReport: HAWKERS_REPORT_FR_FR,
		...event,
	},
	org: {
		vendors: vendors_FR_FR,
		integrations,
		categories,
		products: ORG_PRODUCTS_FR_FR,
		cdp,
	},
	team: TEAM_FR_FR,
	noAuth,
	recovery: {
		registerEmail: REGISTER_EMAIL_FR_FR,
	},
});

export { fr };
